import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component, ElementRef,
    OnDestroy,
    OnInit, ViewChild,
} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {docCSS, getValueOfFieldWithName} from "../../base-behaviour/base.behaviour.doc.types";
import {BasicTemplate} from "../../base-behaviour/template";
import {BasicInfoFieldNames} from "../basic.patient.info.types";
import {GeneralFieldNames} from "../../document-types";
import {DocummentsService} from "../../documents.service";
import {NgIf} from "@angular/common";
import {TranslocoPipe} from "@ngneat/transloco";

@Component({
    selector: 'basic-info-template',
    templateUrl: 'basic.patient.info.template.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        TranslocoPipe

    ],
    standalone: true,
    styles: `
        table {
            width: 100%;
            border-collapse: collapse;
            margin: 0 auto;
        }

        thead {
            background-color: #cdcdcd;
            color: black;
            text-align: center;
        }

        .leftAlignHead {
            background-color: #cdcdcd;
            color: black;
            text-align: left;
        }

        th, td {
            border: 1px solid black;
            padding: 8px;
        }

        body {
            font-family: Arial, sans-serif;
            background-color: #ffffff;
            margin: 0;
            padding: 0;
        }

        .content-container {
            width: 95%;
            padding: 1.5cm 1cm 1.5cm 1cm;
        }

        h1 {
            font-size: x-large;
            text-align: center;
            font-weight: bold;
        }

        h4 {
            color: #8e8e8e;
            text-align: right;
            font-size: small;
            font-weight: bold;
        }

        .section {
            margin-bottom: 15px;
        }

    `
})
export class BasicInfoTemplate extends BasicTemplate implements OnInit, OnDestroy {
    @ViewChild('printableDoc') printableDoc!: ElementRef;
    protected readonly BasicInfoFieldNames = BasicInfoFieldNames;
    protected readonly GeneralFieldNames = GeneralFieldNames;


    constructor(
        route: ActivatedRoute,
        router: Router,
        _docsService:DocummentsService,
        _cdref: ChangeDetectorRef,
    ) {
        super(_docsService, _cdref, router, route);
    }

    ngOnInit(): void {
        this.init();
    }

    ngOnDestroy(): void {
        this.destroy();
    }


    public getFieldData(key: string) {
        return getValueOfFieldWithName(this.docFields, key);
    }

    hasLegalRep() {
        const legalRepName = this.getFieldData(BasicInfoFieldNames.basic_prenumeLegalPers);
        return !!legalRepName;
    }

    protected readonly getValueOfFieldWithName = getValueOfFieldWithName;
}
